import { jsx, jsxs } from 'react/jsx-runtime';
import { useGoogleLogin } from '@react-oauth/google';
import clsx from 'clsx';
import { ButtonBase } from '../../../ButtonBase/ButtonBase.js';
import { Image } from '../../../Image/Image.js';
import { Text } from '../../../Text/Text.js';
import css from './google-login-button.module.css.js';

function GoogleLoginButton({
  onSuccess,
  onError,
  onNonOAuthError,
  iconOnly
}) {
  const login = useGoogleLogin({
    onSuccess,
    onError,
    onNonOAuthError,
    flow: 'auth-code'
  });
  /**
   * This is only because we currently only support React.MouseEventHandler<HTMLButtonElement>
   * in ButtonBase's onClick prop.
   */
  function handleClick() {
    login();
  }
  return jsx(ButtonBase, {
    className: clsx(css.button, 'h-button w-full rounded border border-solid border-navy transition-all duration-hover disabled:text-gray'),
    onClick: handleClick,
    children: jsxs("div", {
      className: clsx('flex w-full items-center', iconOnly ? 'justify-center' : 'justify-start'),
      children: [jsx("div", {
        className: clsx('h-lg w-lg shrink-0', iconOnly ? 'ml-0' : 'ml-sm'),
        children: jsx(Image, {
          src: "/icons/google.svg",
          alt: ""
        })
      }), !iconOnly && jsx("div", {
        className: "mr-sm w-full",
        children: jsx(Text, {
          fontWeight: "semibold",
          children: "Connect With Google"
        })
      })]
    })
  });
}

export { GoogleLoginButton };
